module.exports = __webpack_public_path__ + "img/edge_activites_zoo.6f8a04b0.svg";